module.exports = __webpack_public_path__ + "assets/img/0664.509e9cb6.png";